module.exports = __webpack_public_path__ + "static/vad-cover-406311ca25eb685096b6fd324eaaa112.png";